import React from 'react';
import { useTheme } from '../context/ThemeContext';

const About = () => {
  const { theme } = useTheme();

  return (
    <section 
      id="about" 
      className={`${theme.layout.sectionSpacing} ${theme.colors.background}`}
      data-testid="about-section"
    >
      <div className={theme.layout.container}>
        {/* Header */}
        <div className="text-center mb-16">
          <span className={`
            ${theme.typography.bodyFont} text-[#ff5218]
            uppercase tracking-widest text-sm font-semibold
          `}>
            Who We Are
          </span>
          <h2 className={`
            ${theme.typography.headingFont} ${theme.typography.headingWeight}
            ${theme.colors.textPrimary} text-3xl md:text-4xl lg:text-5xl mt-4
            ${theme.typography.headingTracking} uppercase
          `}>
            Transforming Spaces, Elevating Experiences
          </h2>
        </div>

        {/* Content */}
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className={`${theme.typography.bodyFont} ${theme.colors.textSecondary} text-base md:text-lg leading-relaxed mb-6`}>
              At Sydney Roof Painters, we are more than just a painting and decoration company – we are artisans dedicated to transforming spaces and elevating experiences. With a rich history of craftsmanship and a commitment to excellence, our team of skilled roof painters in Sydney comprises seasoned professionals who bring passion, precision, and creativity to every project.
            </p>
            <p className={`${theme.typography.bodyFont} ${theme.colors.textSecondary} text-base md:text-lg leading-relaxed`}>
              Whether it's residential painting, commercial painting, or intricate decoration services, we take pride in understanding the unique vision of each client and translating it into a work of art.
            </p>
          </div>
          <div className="relative overflow-hidden">
            <img 
              src="/images/site/team.jpg"
              alt="Sydney Roof Painters professional roof painting team in Sydney"
              className="w-full h-auto rounded-lg"
              loading="lazy"
              width="600"
              height="400"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
